/**
 *
 * @author Matthew Rawson @ 22/02/2018 10:28
 * @description
 * @notes
 */
import React, {Component} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import {range} from "lodash"

import id from "@irati/utils/id"
import {injectIntl, FormattedMessage} from "@irati/utils/lang"
import connect from "@irati/store/connect"
import {minWidthMedia} from "@irati/ui/src/global/media"
import {greys} from "@irati/ui/src/global/colors"

import ProgressButton from "./ProgressButton"
import Bar from "./Bar"


const Wrapper = styled.div`
  display: flex;
  justify-content: ${({isMobile}) => (isMobile ? "center" : "space-between")};
  position: relative;
  margin: 0 20px;
  ${minWidthMedia.tablet`
    min-width: 50%;
    margin: 0 80px;
  `}
`


const MobileLabel = styled.div`
  color: ${greys.medium};
  text-transform: uppercase;
  text-align: center;
  font-size: 10px;
  line-height: 15px;
`
const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex: 1;
`

class ProgressBar extends Component {
  static propTypes = {
    disabled: PropTypes.bool,
    questionObj: PropTypes.object,
    onClick: PropTypes.func,
    mq: PropTypes.object.isRequired
  }
  static defaultProps = {
    disabled: false,
    questionObj: {},
    onClick: () => (undefined)
  }


  constructor(props) {
    super(props)
    this.state = {}
  }


  render() {
    const idNamespace = id("ProgressBar", this.props)
    const {questionObj, disabled} = this.props
    const isMobile = this.props.mq.lessThan.medium || questionObj.totalQuestions > 10

    /* eslint-disable max-len */
    return (
      <Wrapper isMobile={isMobile}>

        {isMobile && (
          <MobileLabel>
            <FormattedMessage id="insights.userSurvey.progressBar.toolTip.text" />
            <br />

            {questionObj.questionNumber} <FormattedMessage id="insights.userSurvey.progressBar.mobile.text" /> {questionObj.totalQuestions}</MobileLabel>
        )}

        {!isMobile && (
          <Bar
            id={idNamespace}
            progressPercentage={((questionObj.questionNumber - 1) / (questionObj.totalQuestions - 1)) * 100} />
        )}
        <ButtonWrapper>
          {!isMobile && range(questionObj.totalQuestions).map((index) => (
            <ProgressButton
              id={id(index, idNamespace)}
              key={index}
              disabled={disabled}
              isUpComing={questionObj.questionNumber < index + 1}
              isActive={questionObj.questionNumber === index + 1}
              onClick={() => this.props.onClick(index)}>
              <FormattedMessage id="insights.userSurvey.progressBar.toolTip.text" /> {index + 1}
            </ProgressButton>
          ))}
        </ButtonWrapper>

      </Wrapper>
    )
  }
}

const mapStateToProps = ({mq}) => ({mq})

export default injectIntl(connect(mapStateToProps)(ProgressBar))
